// extracted by mini-css-extract-plugin
export var chevron = "_ms-4";
export var chevronExpanded = "_ms-5";
export var row = "_ms-0";
export var rowBody = "_ms-6";
export var rowDescription = "_ms-7";
export var rowHeader = "_ms-1";
export var rowTitle = "_ms-2";
export var rowTitleComplete = "_ms-3";